import { createContext, useContext, useEffect, useMemo, useState } from "react";
import products from "../data/products";
import usePreload from "../hooks/usePreload";

const LightContext = createContext(null);

export function LightProvider({ children }) {
  const [lit, setLit] = useState(false);
  const [overrides, setOverrides] = useState({});

  const sources = useMemo(
    () =>
      products.flatMap((p) =>
        [p.off, p.on, p.room, p.extra].filter(Boolean)
      ),
    []
  );
  const { ready, progress } = usePreload(sources);

  useEffect(() => {
    document.body.dataset.lit = String(lit);
  }, [lit]);

  const isLit = (id) => (id in overrides ? overrides[id] : lit);

  const toggleAll = () => {
    setOverrides({});
    setLit((v) => !v);
  };

  const toggleOne = (id) =>
    setOverrides((prev) => ({ ...prev, [id]: !isLit(id) }));

  const value = { lit, isLit, toggleAll, toggleOne, ready, progress };

  return (
    <LightContext.Provider value={value}>{children}</LightContext.Provider>
  );
}

export function useLight() {
  const ctx = useContext(LightContext);
  if (!ctx) throw new Error("useLight must be used inside <LightProvider>");
  return ctx;
}
